/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Forge Partner Development
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

// More info here:
// https://github.com/Autodesk-Forge/forge-bim360-issues/blob/master/bim360issues/wwwroot/js/BIM360IssueExtension.js

var pushPinExtension;

function initPushPinExtension(callback) {
  pushPinExtension = viewer.getExtension('Autodesk.BIM360.Extension.PushPin');

  if (pushPinExtension == null) {
    var extensionOptions = {
      hideRfisButton: true,
      hideFieldIssuesButton: true
    };
    viewer.loadExtension('Autodesk.BIM360.Extension.PushPin', extensionOptions).then(function () {
      pushPinExtension = viewer.getExtension('Autodesk.BIM360.Extension.PushPin');
      callback();
    });
  } else {
    callback();
  }
}

function createPushPin(button) {
  initPushPinExtension(function () {
    addPushPin(button);
  });
}

function addPushPin(button) {
  $('.pushpin__notice').addClass('pushpin-notice-active');
  pushPinExtension.removeAllItems();

  var buttonSelector = '#create-issue__modal-pushpin-button';
  var buttonIconSelector = '.create-issue__modal-pushpin-icon';
  var buttonTextSelector = '.create-issue__modal-pushpin-text';
  var labelValueSelector = '#create-issue__modal-title';

  if (button == 'protocol') {
    app.showProtocolModal && app.showProtocolModal.hide();
    app.protocolItemModal && app.protocolItemModal.hide();

    buttonSelector = '#protocol-item-modal__pushpin-button';
    buttonIconSelector = '.protocol-item-modal__pushpin-icon';
    buttonTextSelector = '.protocol-item-modal__pushpin-text';
    labelValueSelector = '#protocol-item-modal__title';
  } else {
    app.createIssueModal && app.createIssueModal.hide();
  }

  const addPushPinEvent = function (e) {
    pushPinExtension.pushPinManager.removeEventListener('pushpin.created', addPushPinEvent);
    if (button == 'protocol') {
      app.showProtocolModal && app.showProtocolModal.show();
      app.protocolItemModal && app.protocolItemModal.show();
    } else {
      app.createIssueModal && app.createIssueModal.show();
    }

    $('.pushpin__notice').removeClass('pushpin-notice-active');
    $(buttonSelector).addClass('push-pin-added');
    $(buttonIconSelector).removeClass('icon-location-on').addClass('icon-location-check');
    $(buttonTextSelector).html(__('pushPinNoticeChangePushPinLocation'));
    pushPinExtension.endCreateItem();
    pushPinExtension.showAll();
    // pushPinExtension.pushPinManager.removeItemById('0');

    // now prepare the data
    // var selected = getSelectedNode();
    // var target_urn = selected.urn.split('?')[0];
    // var starting_version = Number.parseInt(selected.version);
    // https://forge.autodesk.com/en/docs/bim360/v1/tutorials/pushpins/create-pushpin/
    // Once the user clicks the ``Create Pushpin`` button (see step 3), you need to grab the current position of the newly created pushpin and the pushpin data using its ID, which is automatically set to ``0``.

    //in the latest version of  Pushpin Extension, the index is as normal, from 0 and the last item is the newly added item
    var currentPushpinList = pushPinExtension.pushPinManager.pushPinList;
    var issue = pushPinExtension.getItemById(currentPushpinList[currentPushpinList.length - 1].itemData.id);

    var ids = getProjectIds();
    console.log('ids', ids);

    if (issue === null) return; // safeguard

    var data = {
      // type: 'quality_issues', //issue.type,
      // attributes: {
      //   // title: issue.label, // In our example, this is the ``title`` the user sets in the form data (see step 3).
      //   // The extension retrieved the ``type`` and ``status`` properties in step 3, concatenated them, added a dash, and
      //   // assigned the new string to the ``status`` property of the newly created pushpin object. For example, ``issues-
      //   // open``.
      //   // You now need to extract the ``status`` (``open``) from the pushpin object.
      //   //////////status: issue.status.split('-')[1] || issue.status,
      //   // The ``target_urn`` is the ID of the document (``item``) associated with an issue; see step 1.
      //   // target_urn: target_urn,
      //   starting_version: 1, // See step 1 for the version ID.

      //   // The issue type ID and issue subtype ID. See GET ng-issue-types for more details.
      //   //ng_issue_subtype_id: "f6689e90-12ee-4cc8-af7a-afe10a37eeaa",
      //   //ng_issue_type_id: '35f5c820-1e13-41e2-b553-0355b2b8b3dd',

      //   // ``sheet_metadata`` is the sheet in the document associated with the pushpin.
      //   sheet_metadata: {
      //     // `viewerApp.selectedItem` references the current sheet
      //     is3D: viewer.model.is3D,
      //     sheetGuid: viewer.model.getDocumentNode().data.guid,
      //     sheetName: viewer.model.getDocumentNode().data.name
      //   },
      //   pushpin_attributes: {
      //     // Data about the pushpin
      //     type: 'TwoDVectorPushpin', // This is the only type currently available
      //     object_id: issue.objectId, // (Only for 3D models) The object the pushpin is situated on.
      //     location: issue.position, // The x, y, z coordinates of the pushpin.
      //     viewer_state: issue.viewerState // The current viewer state. For example, angle, camera, zoom.
      //   }
      // }

      // TODO This data is wrong

      linkedDocuments: [
        {
          type: "TwoDVectorPushpin",
          urn: ids.hubIdDecoded,
          createdAtVersion: 1,
          details: {
            viewable: {
              id: viewer.model.getDocumentNode().data.guid,
              name: issue.label,
              is3D: viewer.model.is3D
            },
            position: issue.position,// The x, y, z coordinates of the pushpin.
            objectId: issue.objectId, // (Only for 3D models) The object the pushpin is situated on.
            viewerState: issue.viewerState // The current viewer state. For example, angle, camera, zoom.
          }
        }
      ],
    };

    $(buttonSelector).data('pushpin-data', data);
  };

  pushPinExtension.pushPinManager.addEventListener('pushpin.created', addPushPinEvent);

  pushPinExtension.startCreateItem({
    label: $(labelValueSelector).val() || 'PushPin',
    status: 'open',
    type: 'issues'
  });
}

function showPushPins() {
  initPushPinExtension(function () {
    $('.issues__pushpins-button').addClass('pushpins-active');
    $('.issues__pushpins-button .button__icon').removeClass('icon-location-off').addClass('icon-location-on');

    if (!app.issues) {
      return;
    }
    pushPinExtension.removeAllItems();
    pushPinExtension.showAll();

    var pushpinDataArray = [];

    $.each(app.issues, function (index, issue) {

      // add the pushpin
      var pushpinAttributes = issue.linkedDocuments && issue.linkedDocuments[0] ? issue.linkedDocuments[0] : null;
      if (pushpinAttributes) {

        // pushpinDataArray.push({
        //   id: issue.id,
        //   label: issue.title,
        //   status: issue.status || 'open',
        //     // issue.type && issue.status.indexOf(issue.type) === -1
        //     //   ? `${issue.type}-${issue.status}`
        //     //   : issue.status,
        //   position: pushpinAttributes.details.position,
        //   type: 'issues',
        //   objectId: pushpinAttributes.details.objectId,
        //   viewerState: pushpinAttributes.details.viewerState
        // });

        pushPinExtension.pushPinManager.addItem({
          //pushPinExtension.createItem({
          id: issue.id, // The issue ID.
          label: issue.title, // The value displayed when you select the pushpin.
          // The shape and color of the pushpin, in the following format: ``type-status`` (e.g., ``issues-open``).
          status: issue.type && issue.status.indexOf(issue.type) === -1 ?
            `${issue.type}-${issue.status}` : issue.status,
          position: pushpinAttributes.details.position, // The x, y, z coordinates of the pushpin.
          type: 'issues', // The issue type.
          objectId: pushpinAttributes.details.objectId, // (Only for 3D models) The object the pushpin is situated on.
          viewerState: pushpinAttributes.details.viewerState // The current viewer state. For example, angle, camera, zoom.
        });

      }
      // pushPinExtension.loadItemsV2(pushpinDataArray);
    });
  });
}

function showInspectionPushPins(inspectionItems, inspection_id) {
  initPushPinExtension(function () {
    removeInspectionItemPushPins();
    if (inspection_id) {
      $('.inspection-button__wrapper-outer.push-pins-active').removeClass('push-pins-active');
      $('.inspection-button__wrapper-outer[data-id="' + inspection_id + '"]').addClass('push-pins-active');
    }

    pushPinExtension.showAll();

    var pushpinDataArray = [];

    $.each(inspectionItems, function (index, inspectionItem) {
      if (inspectionItem.push_pin_data) {
        var pushPinData = JSON.parse(inspectionItem.push_pin_data);

        if (pushPinData.data && pushPinData.data.attributes && pushPinData.data.attributes.pushpin_attributes) {
          var pushpinAttributes = pushPinData.data.attributes.pushpin_attributes;

          if (pushpinAttributes) {
            pushpinDataArray.push({
              id: inspectionItem.id,
              label: inspectionItem.title,
              status: 'open',
              position: pushpinAttributes.location,
              type: 'issues',
              objectId: pushpinAttributes.object_id,
              viewerState: pushpinAttributes.viewer_state
            });
          }
        }
      }
    });
    pushPinExtension.loadItems(pushpinDataArray);
  });
}

function hidePushPins() {
  initPushPinExtension(function () {
    pushPinExtension.removeAllItems();
    $('.issues__pushpins-button').removeClass('pushpins-active');
    $('.issues__pushpins-button .button__icon').removeClass('icon-location-on').addClass('icon-location-off');
  });
}

function togglePushPins() {
  if ($('.issues__pushpins-button').hasClass('pushpins-active')) {
    hidePushPins();
  } else {
    showPushPins();
  }
}

function removeInspectionItemPushPins() {
  initPushPinExtension(function () {
    pushPinExtension.removeAllItems();
    $('.inspection-button__wrapper-outer.push-pins-active').removeClass('push-pins-active');
  });
}

function toggleInspectionItemPushPins(inspection_id) {
  // Disable button
  if ($('.inspection-button__wrapper-outer[data-id="' + inspection_id + '"]').hasClass('push-pins-active')) {
    removeInspectionItemPushPins();
    return;
  }

  // Send request
  $.ajax({
    url: settings.apiEndpoint + '/api/inspection-push-pins/' + inspection_id,
    type: 'GET',
    headers: {
      apiToken: settings.apiToken
    },
    beforeSend: function () { },
    success: function (response) {
      if (response.success) {
        if (response.inspectionItems) {
          showInspectionPushPins(response.inspectionItems, inspection_id);
        }
        return;
      }
      error();
    },
    error: function () {
      error();
    }
  });
}

// *******************************************
// Helper functions
// *******************************************

function getSelectedNode() {
  var node = $('#userHubs').jstree(true).get_selected(true)[0];
  var parent;
  for (var i = 0; i < node.parents.length; i++) {
    var p = node.parents[i];
    if (p.indexOf('hubs') > 0 && p.indexOf('projects') > 0) parent = p;
  }

  if (node.id.indexOf('|') > -1) {
    // Plans folder
    var params = node.id.split('|');
    return { project: parent, urn: params[0], version: params[3] };
  } else {
    // other folders
    for (var i = 0; i < node.parents.length; i++) {
      var parent = node.parents[i];
      if (parent.indexOf('hubs') > 0 && parent.indexOf('projects') > 0) {
        var version = atob(node.id.replace('_', '/')).split('=')[1];
        return {
          project: parent,
          urn: node.type == 'versions' ? id(node.parents[0]) : '',
          version: version
        };
      }
    }
  }
  return null;
}

function id(href) {
  return href.substr(href.lastIndexOf('/') + 1, href.length);
}

function stringOrEmpty(str) {
  if (str == null) return '';
  return str;
}
